import { render, staticRenderFns } from "./certificateType.vue?vue&type=template&id=17b91c3e&scoped=true&"
import script from "./certificateType.vue?vue&type=script&lang=js&"
export * from "./certificateType.vue?vue&type=script&lang=js&"
import style0 from "./certificateType.vue?vue&type=style&index=0&id=17b91c3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b91c3e",
  null
  
)

export default component.exports